import React, { useContext, useState } from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  CustomTableCell,
  CustomTableHeader,
  DeleteIconWrapper,
  Image,
  TableHeader,
  TableWrapper,
} from "../box/table_styled";
import deleteIcon from "../../assets/delete.svg";
import { Context } from "../../context/app_context";
import {
  deleteBoxFromEmptyReport,
  getEmptyBoxReplace,
  replaceBoxFromEmptyReport,
} from "../../services/box/box";
import { toast } from "react-toastify";
import DecisionDialog from "../picking_list/dialog";
import { Box } from "../../entities/box.entity";

export default function EmptyBoxReportTable({
  data,
  reload,
}: {
  data: any;
  reload: () => void;
}) {
  const { setLoading } = useContext(Context);

  const [currentBox, setCurrentBox] = useState<any>();
  const [currentReplaceBox, setCurrentReplaceBox] = useState<any>();
  const [currentReplaceReplacementBox, setCurrentReplaceReplacementBox] =
    useState<any>();
  const [showDeleteBoxDialog, setShowDeleteBoxDialog] =
    useState<boolean>(false);

  const handleReplaceBox = async (
    boxId: number,
    replaceBoxId: number,
    replaceReplacementBoxId: number
  ) => {
    setLoading(true);
    const deleteResponse = await replaceBoxFromEmptyReport({
      boxId,
      replaceBoxId,
      replaceReplacementBoxId,
    });
    if (deleteResponse.status == 200) {
      toast.success(`Box ${boxId} replaced`);
    } else {
      toast.error(deleteResponse.response.message);
    }
    setLoading(false);
    reload();
  };
  const handleDeleteBox = async (boxId: number) => {
    setLoading(true);
    const deleteResponse = await deleteBoxFromEmptyReport(boxId);
    if (deleteResponse.status == 200) {
      toast.success(`Box ${boxId} deleted`);
    } else {
      toast.error(deleteResponse.response.message);
    }
    setLoading(false);
    reload();
  };

  const handleReplaceOrDeleteBox = async () => {
    if (currentReplaceBox) {
      handleReplaceBox(
        currentBox.id,
        currentReplaceBox.id,
        currentReplaceReplacementBox?.id
      );
    } else {
      handleDeleteBox(currentBox.id);
    }
  };

  const handleShowDeleteBoxDialog = async (box: any) => {
    setLoading(true);
    setCurrentBox(box);
    const dateFrom = new Date();
    dateFrom.setDate(dateFrom.getDate() - 30);
    const dateTo = new Date();
    const replaceResponse = await getEmptyBoxReplace({
      brand: box.brand,
      dateFrom,
      dateTo,
      priority: box.priority,
    });
    if (replaceResponse.status == 200) {
      setCurrentReplaceBox(replaceResponse.data[0]);
      setCurrentReplaceReplacementBox(replaceResponse.data[1]);
      setShowDeleteBoxDialog(true);
    } else {
      toast.error(replaceResponse.response.message);
    }
    setLoading(false);
  };

  return (
    <>
      <TableWrapper>
        <TableHeader>
          <Typography variant="h5">Total Count {data.count}</Typography>
        </TableHeader>
        <TableHeader>
          <Typography variant="h5">Empty Boxes Report</Typography>
        </TableHeader>
        <TableContainer component={Paper} sx={{ p: 1 }}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow sx={{ borderBottom: "1px solid black" }}>
                <CustomTableHeader background_strip={0} align="center">
                  Location
                </CustomTableHeader>
                <CustomTableHeader
                  background_strip={1}
                  align="center"
                  sx={{ minWidth: "140px", maxWidth: "140px" }}
                >
                  Box ID
                </CustomTableHeader>

                <CustomTableHeader background_strip={0} align="center">
                  Priority
                </CustomTableHeader>
                <CustomTableHeader background_strip={1} align="center">
                  Actions
                </CustomTableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.getBoxes
                .sort((a: any, b: any) => {
                  return (
                    a.location.localeCompare(b.location) ||
                    a.priority - b.priority
                  );
                })
                .map((box: any) => {
                  return (
                    <>
                      <TableRow key={`box_item:${box.id}`}>
                        <CustomTableCell
                          background_strip={0}
                          align="center"
                          style={{ fontSize: "32px" }}
                        >
                          {box.location}
                        </CustomTableCell>
                        <CustomTableCell
                          background_strip={1}
                          align="center"
                          style={{ fontSize: "32px" }}
                        >
                          {box.id}
                        </CustomTableCell>
                        <CustomTableCell
                          background_strip={0}
                          align="center"
                          style={{ fontSize: "32px" }}
                        >
                          {box.priority}
                        </CustomTableCell>

                        <CustomTableCell background_strip={1} align="center">
                          <DeleteIconWrapper>
                            <Image
                              src={deleteIcon}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleShowDeleteBoxDialog(box);
                              }}
                              data-cy={`delete_item`}
                            />
                          </DeleteIconWrapper>
                        </CustomTableCell>
                      </TableRow>
                    </>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </TableWrapper>
      <DecisionDialog
        title={<>Replace With</>}
        content={
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <Paper sx={{ minWidth: "fit-content", padding: "10px" }}>
                <Typography variant="h4">Current</Typography>
                <Typography variant="h4">
                  Box: <strong>{currentBox?.id} </strong>
                </Typography>
                <Typography variant="h4">
                  Location: <strong>{currentBox?.location}</strong>
                </Typography>
                <Typography variant="h4">
                  Priority: <strong>{currentBox?.priority}</strong>
                </Typography>
              </Paper>

              {currentReplaceBox ? (
                <Paper sx={{ minWidth: "fit-content", padding: "10px" }}>
                  <Typography variant="h4">Replace</Typography>
                  <Typography variant="h4">
                    Box: <strong>{currentReplaceBox?.id} </strong>
                  </Typography>
                  <Typography variant="h4">
                    Location: <strong>{currentReplaceBox?.code}</strong>
                  </Typography>
                  <Typography variant="h4">
                    Priority: <strong>{currentReplaceBox?.priority}</strong>
                  </Typography>
                </Paper>
              ) : (
                <></>
              )}

              {currentReplaceReplacementBox ? (
                <Paper sx={{ minWidth: "fit-content", padding: "10px" }}>
                  <Typography variant="h4">Replace</Typography>
                  <Typography variant="h4">
                    Box: <strong>{currentReplaceReplacementBox?.id} </strong>
                  </Typography>
                  <Typography variant="h4">
                    Location:{" "}
                    <strong>{currentReplaceReplacementBox?.code}</strong>
                  </Typography>
                  <Typography variant="h4">
                    Priority:{" "}
                    <strong>{currentReplaceReplacementBox?.priority}</strong>
                  </Typography>
                </Paper>
              ) : (
                <></>
              )}
            </div>
          </>
        }
        button1Text={currentReplaceBox ? "REPLACE" : 'DELETE'}
        button2Text={"CANCEL"}
        open={showDeleteBoxDialog}
        setOpen={() => setShowDeleteBoxDialog(false)}
        handleDecision={() => handleReplaceOrDeleteBox()}
      />
    </>
  );
}
